import React from "react";

const String_Types = () => {
  return (
    <div>
      <h1>String_Types Component</h1>
      <p>Content for String_Types goes here...</p>
    </div>
  );
};

export default String_Types;
